import React,{useState} from 'react';
import ReCAPTCHA from "react-google-recaptcha";
import {Link, useNavigate,useLocation} from 'react-router-dom';


const LoginForm = (props) => {

    const [email, setEmail] = useState({ value:'', error: '', isRequired: false });
    const [password, setPassword] = useState({ value:'', error: '', isRequired: false });
    const location=useLocation()
    const {pathname}=location 

      const validation = () => {
        let regex = /^[\w._-]+[+]?[\w._-]+@[\w.-]+\.[a-zA-Z]{2,6}$/;
        var passRegex = /^(?=.*[0-9])(?=.*[!@#$%^&*])[a-zA-Z0-9!@#$%^&*]{6,16}$/;
        let formIsValid = true

        if (!email.value) {
            formIsValid = false
            let msg = "Please enter your email"
            setEmail({...email,error:msg})
        }
        if(email.value && (email.value.length < 13) || email.value && (email.value.length > 64)){
            formIsValid = false
            let msg = "Max 64 Character Length Min 3 Character Length"
            setEmail({...email,error:msg})
        }
        if(email.value && !(regex.test(email.value))){
            formIsValid = false
            let msg = "Enter a valid Email ID (Ex: abc@gmail.com)"
            setEmail({...email,error:msg})
        }

        if (!password.value) {
            formIsValid = false
            let msg = "Please enter your password"
            setPassword({...password,error:msg})
        }


        if(formIsValid){
            setEmail({...email,error:''})
            setPassword({...password,error:''})
        }
        return formIsValid
    }

      const onSubmit = (e) => {
        e.preventDefault();

        if(validation()){
            const data = {
                email: email.value,
                password: password.value,
                device_type:"Web",
                device_id:"hdfgsjhd8784##%^$%",
                device_token:""
            }
            
            props.onSubmit(data)
        }
    }

  return (
    <form onSubmit={onSubmit}>
    <div className="row">
        <div className="col-lg-12 mb-3">
            <div className="form-floating">
            <input
                type="text"
               className="form-control"
                name="email"
                placeholder="Email"
                value={email.value}
                onChange={(e) => setEmail({...email,value:e.target.value, error : ''})}
            />
                <label>Email address</label> 
            </div>
            {email.error.length>0 &&<div className='invalidFeedback'>{email.error}</div>}


        </div>
        <div className="col-lg-12 mb-3">
            <div className="pass_word form-floating ">
            <input
                type="password"
               className="form-control"
                name="password"
                placeholder="Password"
                value={password.value}
                onChange={(e) => setPassword({...password,value:e.target.value, error :''})}
            />
                <label>Password</label>
            </div>
            {password.error.length>0 &&<div className='invalidFeedback'>{password.error}</div>}
            {/* <div className='invalidFeedback'>
                <ErrorMessage  name="password" />
            </div> */}
        </div>

        {/* <div className="col-lg-12 mb-3">
            <div className="form-check text-start ps-0">
            <input type="checkbox" name="remember" id="flexCheckChecked" />
                <label className="form-check-label ms-2"  htmlFor="flexCheckChecked">
                    Remember Me
                </label>
            </div>
        </div> */}
        {/* <div className="col-lg-12 col-md-12 col-sm-12 col-12 mb-3 text-start">
            <button type="submit" className="btn btn-primary btn-lg auth_btn">Login</button>
        </div>
        
        <div className="col-lg-12 ">
            <p className="mb-0">Don't have an account ? 
                <Link to="/register"> &nbsp; Register Now</Link>
            </p>
        </div>
        <div className="col-lg-12 col-md-12 col-sm-12 col-12 ">
            <p className="forgot-password mb-2">
                <Link to="/forgot-password">Forgot Password ?</Link>
            </p>
        </div> */}

                
            <div className="col-lg-12 col-md-12 col-sm-12 col-12 mb-3 text-start">
                    <button type="submit" className="btn btn-primary btn-lg auth_btn">Login</button>
                </div>
                
            {pathname!=="/ambassador/login"&& pathname!=="/ambassador"&& pathname!=="/ambassador/" &&<div className="col-lg-5 ">
                <p className="mb-0 login_links_re_for" >Don't have an account ? 
                    <Link to="/register" className="d-block text-decoration-underline"> Register Now</Link>
                </p>
            </div>}

            {pathname!=="/ambassador/login" && pathname!=="/ambassador"&& pathname!=="/ambassador/" ?<div className="col-lg-7 col-md-7 col-sm-12 text-end col-12 ">
                <p className="forgot-password mb-2 login_links_re_for">Cannot access your account? 
                    <Link to="/forgot-password" className='d-block text-decoration-underline'> Forgot Password </Link>
                </p>
            </div>:<div className="col-lg-12 col-md-12 col-sm-12 col-12 ">
                <p className="forgot-password mb-2 login_links_re_for">Cannot access your account?
                    <Link to="/ambassador/forgot-password" className='text-decoration-underline d-block'>Forgot Password </Link>
                </p>
            </div>
            }


    </div>
    </form>
   
    
  )
}

export default LoginForm
